module.exports = __webpack_public_path__ + "fa-brands-400.eot?a7b95dbdd87e0c809570affaf366a434";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.eot
// module id = 21
// module chunks = 0